import React from "react";
import {
    Create,
    TabbedForm,
    FormTab,
    SelectArrayInput,
    ReferenceArrayInput,
    SelectInput,
    ReferenceInput,
    FormDataConsumer
} from 'react-admin';
import "../legal_entity/styles/main.css"
import required from "../helper/Required";

const HealthcareServiceCreate = props => {
    const Title = props => (
        <div className="title-wrapper">
            <span className="title-text">Додавання медичної послуги</span>
        </div>
    );
    
    return (
        <Create {...props} title={<Title {...props} />}>
            <TabbedForm>
                <FormTab contentClassName="legal-entities-tab-content" label={<span>Медична послуга <sup>*</sup></span>}>
                    <ReferenceArrayInput
                        formClassName="tab-content-item"
                        label="Аптеки"
                        source="divisions"
                        reference="divisions"
                        validate={required.validateRequired}
                        filter={{status: 'ACTIVE'}}
                    >
                        <SelectArrayInput optionText="name" />
                    </ReferenceArrayInput>
                    <SelectInput formClassName="tab-content-item" label="Категорія" source="category" validate={required.validateRequired} choices={[
                        // { id: 'MSP', name: 'Господарська діяльність з медичної практики' },
                        { id: 'PHARMACY', name: 'Господарська діяльність з роздрібної торгівлі лікарськими засобами' },
                        { id: 'PHARMACY_DRUGS', name: 'Господарська діяльність з обігу наркотичних засобів, психотропних речовин і прекурсорів' }
                    ]} />
                    <FormDataConsumer formClassName="tab-content-item">
                        {({ formData, ...rest }) => formData.category ?
                            <ReferenceInput
                        formClassName="tab-content-item"
                        label="Ліцензія (номер наказу)"
                        source="licenseId"
                        reference="licenses"
                        filter={{ type: formData.category }}
                        validate={required.validateRequired}
                    >
                        <SelectInput optionText="orderNo" />
                    </ReferenceInput> : null
                        }
                    </FormDataConsumer>
                    <FormDataConsumer formClassName="tab-content-item">
                        {({ formData, ...rest }) => formData.category === 'PHARMACY_DRUGS' ?
                    <SelectInput formClassName="tab-content-item" label="Тип" source="type" validate={required.validateRequired} choices={[
                        { id: 'ACQUISITION', name: 'Придбання наркотичних засобів, психотропних речовин і прекурсорів' },
                        { id: 'PRODUCTION', name: 'Виробництво наркотичних засобів, психотропних речовин і прекурсорів' },
                        { id: 'SALE', name: 'Реалізація (відпуск) наркотичних засобів, психотропних речовин і прекурсорів' },
                        { id: 'STORAGE', name: 'Зберігання наркотичних засобів, психотропних речовин і прекурсорів' },
                        { id: 'USE', name: 'Використання наркотичних засобів, психотропних речовин і прекурсорів' }
                    ]} /> : null
                        }
                    </FormDataConsumer>
                    {/*<SelectInput formClassName="tab-content-item" label="Спеціалізація" source="specialityType" choices={[*/}
                    {/*    {id: 'PHARMACIST', name: 'Фармація'},*/}
                    {/*    {id: 'PROVISOR', name: 'Загальна фармація'},*/}
                    {/*    {id: 'CLINICAL_PROVISOR', name: 'Клінічна фармація'}*/}
                    {/*]} />*/}
                    {/*<SelectInput formClassName="tab-content-item" label="Умови надання послуги" source="providingCondition" choices={[*/}
                    {/*    {id: 'FIELD', name: 'За місцем знаходження пацієнта'},*/}
                    {/*    {id: 'INPATIENT', name: 'Стаціонарні умови'},*/}
                    {/*    {id: 'OUTPATIENT', name: 'Амбулаторні умови'}*/}
                    {/*]} />*/}
                </FormTab>
            </TabbedForm>
        </Create>
    );
};

export default HealthcareServiceCreate;
